<template>
    <div>
      <section>
        <!-- Top Navigation Bar -->
        <v-app-bar
          :clipped-left="clipped"
          color="#FFFFFF"
          fixed
          nav
          elevation="0"
          app
          :class="clipped ? 'clipped' : ''"
          style="border-radius: 0px; z-index: 9; border-bottom: 1px solid #E5E7EB;">
          
          <v-app-bar-nav-icon class="hidden-lg-and-up" @click.stop="drawer = !drawer"/>
          
          <v-toolbar-title 
            class="d-flex align-center"
            :style="clipped ? 'padding-left: 6px;' : ''">
            <div v-if="clipped"
              class="mr-8">
              <v-img
                @click="clipped = false"
                contain
                width="40"
                height="40"
                alt="kominfoklaten"  
                :src="Object.keys(company).length > 0 ? company.fav_icon : require('@/assets/logo/favicon.png')"
                class="ma-auto cursor-pointer">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      size="20"
                      indeterminate 
                      :color="set_color">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </div>
  
            <div v-if="user.role === 'admin' && ($route.path === '/program-p1' || $route.path === '/program' || $route.path === '/laporan/perkembangan' || $route.path === '/program-perubahan' || $route.path === '/laporan/kendala' || $route.path === '/laporan/capaian')">
              <div v-if="user.role === 'admin'" style="width: 500px;">
                <v-autocomplete
                  rounded
                  :color="set_color"
                  placeholder="Pilih Unit"
                  hide-details
                  height="43"
                  :items="unit"
                  item-text="title"
                  item-value="id"
                  :item-color="set_color"
                  @click:clear="filter.unit_id = ''; changeQuery();"
                  v-on:change="changeQuery()"
                  v-model="filter.unit_id"
                  style="background: #F9FAFB; border: 1px solid #E5E7EB;">
                </v-autocomplete>
              </div>
            </div>
          </v-toolbar-title>
  
          <v-spacer/>
  
          <!-- Right Side Actions -->
          <div class="d-flex align-center">
            <!-- Language Selector -->
            <v-menu
              transition="slide-x-transition"
              bottom
              right
              offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  text
                  v-bind="attrs"
                  v-on="on"
                  class="mr-3"
                  style="color: #6B7280;">
                  <span class="text-uppercase">EN</span>
                  <v-icon right size="16">mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list style="min-width: 120px;">
                <v-list-item @click="">
                  <v-list-item-title class="text-uppercase">EN</v-list-item-title>
                </v-list-item>
                <v-list-item @click="">
                  <v-list-item-title class="text-uppercase">ES</v-list-item-title>
                </v-list-item>
                <v-list-item @click="">
                  <v-list-item-title class="text-uppercase">JP</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <!-- Notifications -->
            <v-menu
              transition="slide-x-transition"
              bottom
              right
              offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  class="mr-3"
                  style="position: relative;">
                  <v-badge
                    :content="notifications.length"
                    :value="notifications.length > 0"
                    color="error"
                    overlap>
                    <v-icon color="#6B7280">mdi-bell-outline</v-icon>
                  </v-badge>
                </v-btn>
              </template>
              <v-card style="min-width: 320px; max-width: 400px;">
                <v-card-title class="text-h6 pa-4 pb-2">
                  Notifications
                </v-card-title>
                <v-divider></v-divider>
                <v-list style="max-height: 300px; overflow-y: auto;">
                  <v-list-item v-for="(notification, index) in notifications" :key="index">
                    <v-list-item-content>
                      <v-list-item-title class="body-2">{{ notification.title }}</v-list-item-title>
                      <v-list-item-subtitle class="caption">{{ notification.time }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="notifications.length === 0">
                    <v-list-item-content>
                      <v-list-item-title class="text-center text--secondary">No notifications</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
                <v-divider></v-divider>
                <v-card-actions class="pa-3">
                  <v-btn text small color="primary">View All</v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>

            <!-- User Menu -->
            <v-menu
              transition="slide-x-transition"
              bottom
              right
              offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-list 
                  flat 
                  dense
                  color="transparent"
                  style="max-width: 200px;">
                  <v-list-item 
                    v-bind="attrs"
                    v-on="on"
                    class="px-3 py-2"
                    style="border-radius: 8px; background: #F9FAFB; border: 1px solid #E5E7EB;">
                    <v-list-item-avatar 
                      size="32"
                      class="mr-3">
                      <v-img 
                        width="100%"
                        height="100%"
                        alt="kominfoklaten"  
                        :src="user.image_url !== undefined && user.image_url !== '' ? user.image_url : require('@/assets/image/member_default.png')"
                        class="ma-auto"
                        style="border-radius: 50%;">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-list-item-avatar>
  
                    <v-list-item-content>
                      <v-list-item-title
                        class="body-2 font-weight-medium text--darken-1">
                        {{ user.name }}
                      </v-list-item-title>
                      <v-list-item-subtitle class="caption text--secondary">
                        Signed in as {{ user.email || 'user@example.com' }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
  
                    <v-list-item-action>
                      <v-icon color="#6B7280">mdi-chevron-down</v-icon>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </template>
  
              <v-list style="min-width: 200px;">
                <v-list-item @click="toMenu({title: 'Profile', type: 'profile', link: '/profile?menu=profile'})">
                  <v-list-item-icon class="mr-3">
                    <v-icon size="18">mdi-account-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="body-2">Profile</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item @click="toMenu({title: 'Settings', type: 'settings', link: '/settings'})">
                  <v-list-item-icon class="mr-3">
                    <v-icon size="18">mdi-cog-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="body-2">Settings</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item @click="toMenu({title: 'Keluar', type: 'logout', link: '#'})">
                  <v-list-item-icon class="mr-3">
                    <v-icon size="18">mdi-logout</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="body-2">Sign out</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </v-app-bar>
  
        <!-- White Sidebar (Raven Style) -->
        <v-navigation-drawer
          v-model="drawer"
          :mini-variant.sync="clipped"
          v-if="!date_password"
          width="280"
          color="#FFFFFF"
          dark
          fixed
          app
          style="border-right: 1px solid #E5E7EB;">
          
          <!-- Logo Section -->
          <div
            class="d-flex align-center justify-space-between pa-4"
            style="height: 70px; background: #FFFFFF; border-bottom: 1px solid #E5E7EB;">
            <div v-if="!clipped" class="d-flex align-center">
              <v-img
                contain
                width="120"
                height="30"
                alt="kominfoklaten"  
                :src="Object.keys(company).length > 0 ? company.logo : require('@/assets/logo/favicon_full.png')"
                class="ma-auto">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      size="20"
                      indeterminate 
                      :color="set_color">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </div>
            
            <div v-if="clipped" class="d-flex align-center justify-center">
              <v-img
                contain
                width="32"
                height="32"
                alt="kominfoklaten"  
                :src="Object.keys(company).length > 0 ? company.fav_icon : require('@/assets/logo/favicon.png')"
                class="ma-auto">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      size="20"
                      indeterminate 
                      :color="set_color">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </div>
  
            <v-btn 
              v-if="!clipped"
              @click="clipped = !clipped ? true : false"
              icon
              small
              style="background: #F3F4F6;">
              <v-icon
                size="18"
                color="#6B7280">
                mdi-menu
              </v-icon>
            </v-btn>
          </div>
  
          <!-- Navigation Menu -->
          <v-list
            style="height: calc(100vh - 70px); overflow-y: auto; overflow-x: hidden; padding: 16px 8px; background: #FFFFFF;">
            
            <!-- Main Section -->
            <div class="menu-section">
              <div class="section-header">Menu Utama</div>
              
              <v-list-item 
                v-for="(item, index) in mainMenu"
                :key="index"
                :to="item.link"
                color="transparent"
                :class="[
                  'raven-menu-item',
                  item.link === $route.path ? 'raven-menu-item-active' : ''
                ]">
                
                <v-list-item-avatar
                  size="36"
                  tile
                  class="mr-3"
                  :class="item.link === $route.path ? 'raven-icon-active' : 'raven-icon'"
                  :color="item.link === $route.path ? '#47A891' : 'transparent'"
                  style="border-radius: 8px !important;">
                  <v-icon 
                    size="20"
                    :color="item.link === $route.path ? 'white' : '#4B5563'">
                    {{ item.icon }}
                  </v-icon>
                </v-list-item-avatar>
  
                <v-list-item-content v-if="!clipped">
                  <v-list-item-title
                    class="body-2 font-weight-medium"
                    :class="item.link === $route.path ? 'text-white' : 'text-gray-600'"
                    :style="item.link === $route.path ? 'color: white;' : ''">
                    {{ item.title }} 
                  </v-list-item-title>
                </v-list-item-content>
                
                <!-- Hot Badge -->
                <v-list-item-action v-if="item.hot && !clipped">
                  <v-chip
                    small
                    color="orange"
                    text-color="white"
                    class="caption font-weight-bold">
                    Hot
                  </v-chip>
                </v-list-item-action>
              </v-list-item>
            </div>

            <!-- Pages Section -->
            <div class="menu-section">
              <div class="section-header">Menu Lainnya</div>
              
              <div 
                v-for="(item, index) in pagesMenu"
                :key="index">
                
                                <!-- Single Menu Item -->
                <v-list-item 
                  v-if="item.sub_menu.length < 1"
                  :to="item.link"
                  color="transparent"
                  :class="[
                    'raven-menu-item',
                    item.link === $route.path ? 'raven-menu-item-active' : ''
                  ]">
                  
                  <v-list-item-avatar
                    size="36"
                    tile
                    class="mr-3"
                    :class="item.link === $route.path ? 'raven-icon-active' : 'raven-icon'"
                    :color="item.link === $route.path ? '#47A891' : 'transparent'"
                    style="border-radius: 8px !important;">
                    <v-icon 
                      size="20"
                      :color="item.link === $route.path ? 'white' : '#4B5563'">
                      {{ item.icon }}
                    </v-icon>
                  </v-list-item-avatar>
      
                  <v-list-item-content v-if="!clipped">
                    <v-list-item-title
                      class="body-2 font-weight-medium"
                      :class="item.link === $route.path ? 'text-white' : 'text-gray-600'"
                      :style="item.link === $route.path ? 'color: white;' : ''">
                      {{ item.title }} 
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
    
                <!-- Menu Group with Submenu -->
                <v-list-group
                  v-if="item.sub_menu.length > 0"
                  v-model="item.active"
                  color="#47A891"
                  :append-icon="item.sub_menu.length > 0 ? 'mdi-chevron-down' : ''"
                  no-action
                  :class="clipped ? 'clipped_header' : ''">
                  
                  <template v-slot:activator>
                    <v-list-item-avatar
                      size="36"
                      tile
                      class="mr-3"
                      :class="item.active ? 'raven-icon-active' : 'raven-icon'"
                      :color="item.active ? '#47A891' : 'transparent'"
                      style="border-radius: 8px !important;">
                      <v-icon 
                        size="20"
                        :color="item.active ? 'white' : '#4B5563'">
                        {{ item.icon }}
                      </v-icon>
                    </v-list-item-avatar>
    
                    <v-list-item-content v-if="!clipped">
                      <v-list-item-title
                        class="body-2 font-weight-medium"
                        :class="item.active ? 'text-white' : 'text-gray-600'"
                        :style="item.active ? 'color: white;' : ''">
                        {{ item.title }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
    
                  <v-list-item
                    v-for="(item_sub, index_sub) in item.sub_menu"
                    :key="index_sub"
                    :to="item_sub.link"
                    color="transparent"
                    class="raven-submenu-item"
                    :class="item_sub.link === $route.path ? 'raven-submenu-item-active' : ''">
                    <v-list-item-content>
                      <v-list-item-title
                        class="body-2 font-weight-medium"
                        :class="item_sub.link === $route.path ? 'text-teal' : 'text-gray-600'"
                        :style="item_sub.link === $route.path ? 'color: #47A891;' : ''">
                        {{ item_sub.title }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-group>
              </div>
            </div>
          </v-list>
        </v-navigation-drawer>
      </section>
    </div>
  </template>
  
  <script>
    import { TokenService } from "@/service/Storage.Service";
    import { get, post, put, patch, destroy } from "@/service/Axios";
    export default {
      data () {
        return {
          clipped: false,
          drawer: true,
          total: 0,
          unit: [],
          filter: {unit_id: '501'},
          date_password: false,
          notifications: [
            { title: 'Critical alert: Server crash detected', time: 'Just now' },
            { title: 'Emiliya mentioned you in a comment', time: '1h' },
            { title: 'Backup completed successfully', time: '2h' },
            { title: 'Profile updated successfully', time: '3h' }
          ],
          mainMenu: [
            { title: 'Dashboard', icon: 'mdi-view-dashboard', link: '/sidasi-dashboard', hot: false },
            { title: 'Program I', icon: 'mdi-file-document', link: '/sidasi-program-I', hot: false },
            { title: 'Program II', icon: 'mdi-file-document-outline', link: '/sidasi-program-II', hot: false }
          ],
          pagesMenu: [
            { 
              title: 'Laporan', 
              icon: 'mdi-chart-bar', 
              link: '/laporan', 
              active: false,
              sub_menu: [
                { title: 'Perkembangan', link: '/laporan/perkembangan' },
                { title: 'Kendala', link: '/laporan/kendala' },
                { title: 'Capaian', link: '/laporan/capaian' }
              ]
            },
            { 
              title: 'Master Data', 
              icon: 'mdi-database', 
              link: '/master', 
              active: false,
              sub_menu: [
                { title: 'Unit', link: '/master/unit' },
                { title: 'Program', link: '/master/program' },
                { title: 'Kegiatan', link: '/master/kegiatan' },
                { title: 'Sub Kegiatan', link: '/master/sub-kegiatan' }
              ]
            },
            { 
              title: 'Konfigurasi', 
              icon: 'mdi-cog', 
              link: '/config', 
              active: false,
              sub_menu: [
                { title: 'Pengaturan', link: '/config/settings' },
                { title: 'User Management', link: '/config/users' },
                { title: 'Backup & Restore', link: '/config/backup' }
              ]
            }
          ],
          menu: {
            right: [
              {
                title: 'Profile',
                type: 'profile',
                link: '/profile?menu=profile'
              },
              {
                title: 'Keluar',
                type: 'logout',
                link: '#'
              }
            ],
            left: []
          }
        }
      },
      components: {
        Empty: () => import(/* webpackPrefetch: true */ '@/components/empty')
      },
      computed: {
        user () {
          const fourMonthsAgo = new Date(this.$store.state.user.last_update_password_date);
          fourMonthsAgo.setMonth(fourMonthsAgo.getMonth() + 3);
  
          console.log(fourMonthsAgo)
          if(fourMonthsAgo < new Date()) {
            // this.dialog.password = true
            this.date_password = true
          } else {
            this.date_password = false
          }
          return this.$store.state.user
        },
        dpa () {
          return this.$store.state.dpa
        },
        token () {
          return this.$store.state.token
        },
        reload () {
          return this.$store.state.reload
        },
        company () {
          return this.$store.state.company
        },
        set_color () {
          return this.$store.state.color
        },
        set_color_rgb_up () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r+93}, ${g+120}, ${b+12})`
        },
        set_color_rgb_down () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.2)`
        },
        set_color_rgb_soft () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.05)`
        },
  
        counter () {
          return this.$store.state.counter
        },
  
        tahun_anggaran () {
          return this.$store.state.year
        },
  
        years () {
          let max = new Date('10-01-2024').getFullYear()+6, min = max - 6, years = []
  
          for (let i = max; i >= min; i--) {
            years.push({
              text: i,
              value: i
            })
          }
  
          return years
        }
      },
      watch: {
        '$route.query.unit': function(val) {
          this.filter.unit = val
        },
      },
      created () {
        
      },
      mounted () {
        console.log(this.$store.state.user)
        const debounce = (fn) => {
          let frame;
          return (...params) => {
            if (frame) { 
              cancelAnimationFrame(frame)
            }
            frame = requestAnimationFrame(() => {
              fn(...params)
            })
          } 
        }
  
        const storeScroll = () => {
          document.documentElement.dataset.scroll = window.scrollY
        }
  
        document.addEventListener('scroll', debounce(storeScroll), { passive: true })
        storeScroll()
  
        if (this.$store.state.user.role === 'admin') {
          this.$store.commit("setUnitId", '501')
        } else {
          this.$store.commit("setUnitId", this.$store.state.user.unit_id)
        }
        this.menu.left = this.$store.state.menu
  
        this.fetch()
        this.fetchUnit()
        // this.fetchDpa()
      },
      methods: {
        async fetch () {
          await get('admin/config')
          .then(response => {
            let res = response.data
              
            if (res.status === 200) {
              res.results.data[0].color = JSON.parse(res.results.data[0].color)
  
              TokenService.saveCompany(JSON.stringify(res.results.data[0]))
  
              this.$store.commit("setCompany", res.results.data[0])
              
              if (res.results.data[0].color.length > 0) {
                res.results.data[0].color.map((obj) => {
                  if (obj.active) {
                    TokenService.saveColor(obj.hex)
  
                    this.$store.commit("setColor", obj.hex)
                  }
                })
              } else {
                TokenService.saveColor('#DD5826')
  
                this.$store.commit("setColor", '#DD5826')
              }
  
              this.styles()
  
              this.fetchCounter()
            }
          })
        },
  
        async fetchDpa () {
          let params = {
            tahun: new Date().getFullYear()
          }
          await get('admin/dpa/data', { params })
          .then(response => {
            let res = response.data
              
            if (res.status === 200) {
  
              TokenService.saveDpa(JSON.stringify(res.results.data[0]))
  
              this.$store.commit("setDpa", res.results.data[0])
              
            }
          })
        },
  
        changeQuery () {
  
          TokenService.saveUnitId(this.filter.unit_id)
          this.$store.commit("setUnitId", this.filter.unit_id)
          // if (this.filter.unit_id === '' || this.filter.unit_id === null || this.filter.unit_id === undefined) {
          //   this.$router.replace({'path': `${this.$route.path}`, 'query': {}})
          // } else {
          //   this.$router.replace({'path': `${this.$route.path}`, 'query': {'unit': this.filter.unit_id}})
          // }
        },
  
        async fetchCounter () {
          let counter = {
            total_company_quota: 0,
            total_company_quota_used: 0,
            total_company_quota_sisa: 0
          }
  
          TokenService.saveCounter(JSON.stringify(counter))
  
          this.$store.commit("setCounter", counter)
        },
  
        async toMenu (item) {
          if (item.type === 'logout') {
            TokenService.removeToken()
                
            window.location = '/login'
          } else {
            this.$router.push(item.link)
          }
        },
  
        styles () {
          let style = document.createElement('style')
            
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .v-data-table table .v-data-table-header {
              color: white;
              // background-color: ${this.set_color}; !important;
            }
            .v-data-table table > thead > tr > th {
              // background: ${this.set_color};
            }
  
            .v-data-table table > tbody .v-data-table__selected .v-input--selection-controls__input {
              // color: ${this.set_color};
            }
            .v-data-table table > tbody .v-input--selection-controls__input .v-icon {
              // color: ${this.set_color};
            }
  
            ::-webkit-scrollbar-thumb{
              border-radius: 10px;
              background-color: ${this.set_color};
            }
  
            #iw-container .iw-title {
              font-family: 'Open Sans Condensed', sans-serif;
              font-size: 22px;
              font-weight: 400;
              padding: 10px;
              background-color: ${this.set_color};
              color: white;
              margin: 0;
              border-radius: 2px 2px 0 0;
            }
  
            .v-slide-group__prev .v-icon {
              color: ${this.set_color}; !important;
            }
  
            .v-slide-group__next .v-icon {
              color: ${this.set_color}; !important;
            }
  
            .table-grid table > thead > tr > th:nth-child(1) {
              left: 0; 
              z-index: 5;
              // background: ${this.set_color};
            }
  
            .v-data-table table > tbody > tr:hover .text-start, table > tbody > tr:hover .text-center,  table > tbody > tr:hover .text-end {
              cursor: pointer;
              // background-color: ${this.set_color_rgb_up} !important;
              background-color: #E0E0E0 !important;
              border-radius: 0px !important;
            }
            .v-data-table__selected .text-start, .v-data-table__selected .text-center, .v-data-table__selected .text-end {
              // background-color: ${this.set_color_rgb_up} !important;
              background-color: #E0E0E0 !important;
              border-radius: 0px !important;
            }
          `
  
          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        },
  
        async fetchUnit () {
  
          let params = {
            limit: 100000,
            year: new Date().getFullYear()
          }
          
          await get('admin/unit/data', { params })
          .then(response => {
            let res = response.data
              
            if (res.status === 200) {
              this.unit = res.results.data
              if(this.$route.query.unit !== undefined){
                this.filter.unit_id = this.$route.query.unit
  
              }
            }
          })
        },
  
        set_year (value) {
          this.$store.commit('setYear', value)
          
          TokenService.saveYear(value)
        }
      }
    }
  </script>
  
  <style>
    /* Raven Dashboard Sidebar Styles */
    .sub .v-list-item {
      padding-left: 8px !important;
      padding-right: 8px !important;
    }
  
    .clipped .v-toolbar__content {
      padding-left: 8px;
    }
  
    .v-navigation-drawer--mini-variant {
      width: 68px !important;
    }
  
    .clipped_header .v-list-group__header {
      padding: 0px 13px;
    }

    /* Menu Section Headers */
    .menu-section {
      margin-bottom: 24px;
    }

    .section-header {
      font-size: 11px;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      color: #9CA3AF;
      padding: 0 16px 8px 16px;
      margin-bottom: 8px;
    }

    /* White Sidebar Menu Items */
    .raven-menu-item {
      border-radius: 8px !important;
      margin: 2px 8px;
      transition: all 0.2s ease;
      color: #4B5563;
    }

    .raven-menu-item:hover {
      background-color: #47A891 !important;
      color: #fff !important;
    }

    .raven-menu-item:hover .v-icon {
      color: white !important;
    }

    .raven-menu-item:hover .v-list-item__title {
      color: white !important;
    }

    .raven-menu-item-active {
      background-color: #47A891 !important;
      /* color: white !important; */
    }

    /* White Sidebar Icons */
    .raven-icon {
      background-color: transparent !important;
      transition: all 0.2s ease;
    }

    .raven-icon-active {
      background-color: #47A891 !important;
    }

    /* White Sidebar Submenu */
    .raven-submenu-item {
      padding-left: 48px !important;
      border-radius: 6px !important;
      margin: 1px 8px;
      transition: all 0.2s ease;
      color: #4B5563 !important;
      position: relative;
    }

    .raven-submenu-item::before {
      content: '';
      position: absolute;
      left: 24px;
      top: 50%;
      transform: translateY(-50%);
      width: 1px;
      height: 16px;
      background-color: #E5E7EB;
    }

    .raven-submenu-item:hover {
      background-color: #47A891 !important;
      color: #fff !important;
    }

    .raven-submenu-item:hover .v-list-item__title {
      color: white !important;
    }

    .raven-submenu-item-active {
      background-color: transparent !important;
      color: #47A891 !important;
    }

    /* White Sidebar List Group */
    .v-list-group__header {
      border-radius: 8px !important;
      margin: 2px 8px;
      transition: all 0.2s ease;
      color: #4B5563;
    }

    .v-list-group__header:hover {
      background-color: #47A891 !important;
      color: #fff !important;
    }

    .v-list-group__header:hover .v-icon {
      color: white !important;
    }

    .v-list-group__header:hover .v-list-item__title {
      color: white !important;
    }

    .v-list-group__header.v-list-group__header--active {
      background-color: #47A891 !important;
      /* color: white !important; */
    }

    .v-list-group__items .v-list-item {
      padding-left: 48px !important;
    }

    /* White Sidebar Scrollbar */
    .v-navigation-drawer .v-list::-webkit-scrollbar {
      width: 4px;
    }

    .v-navigation-drawer .v-list::-webkit-scrollbar-track {
      background: #F9FAFB;
      border-radius: 2px;
    }

    .v-navigation-drawer .v-list::-webkit-scrollbar-thumb {
      background: #D1D5DB;
      border-radius: 2px;
    }

    .v-navigation-drawer .v-list::-webkit-scrollbar-thumb:hover {
      background: #9CA3AF;
    }

    /* Text Colors for White Theme */
    .text-white {
      color: white !important;
    }

    .text-gray-600 {
      color: #4B5563;
    }

    .text-gray-500 {
      color: #6B7280 !important;
    }

    .text-teal {
      color: #47A891 !important;
    }

    /* Override Vuetify Colors for White Theme */
    .v-navigation-drawer {
      background-color: #FFFFFF !important;
    }

    .v-navigation-drawer .v-list {
      background-color: #FFFFFF !important;
    }

    .v-navigation-drawer .v-list-item {
      color: #4B5563;
    }

    .v-navigation-drawer .v-list-item:hover {
      background-color: #47A891 !important;
      color: #fff !important;
    }

    .v-navigation-drawer .v-list-item:hover .v-icon {
      color: white !important;
    }

    .v-navigation-drawer .v-list-item:hover .v-list-item__title {
      color: white !important;
    }

    .v-navigation-drawer .v-list-item--active {
      background-color: #47A891 !important;
      color: white !important;
    }

    /* Notification Badge */
    .v-badge__badge {
      background-color: #EF4444 !important;
      color: white !important;
    }

    /* User Menu Styling */
    .v-menu__content {
      border-radius: 8px !important;
      box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
    }

    /* Language Selector */
    .v-btn--text {
      color: #6B7280 !important;
    }

    .v-btn--text:hover {
      background-color: #47A891 !important;
    }

    /* Hot Badge Styling */
    .v-chip--small {
      height: 20px !important;
      font-size: 10px !important;
    }

    /* Custom CSS Variables */
    :root {
      --v-primary-base: #47A891;
    }
  </style>